import { Component, OnInit } from '@angular/core';
import { AgentBoardDashboardService } from './agent-board-dashboard.service';
import { ActivatedRoute } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { ServiceLevelBoardService } from './agent-board-servicelevel.service';

@Component({
  selector: 'app-agent-board-dashboard',
  templateUrl: './agent-board-dashboard.component.html',
  styleUrls: ['./agent-board-dashboard.component.scss']
})
export class AgentBoardDashboardComponent implements OnInit {

  maximumSkillSetsAgent: number;
  maximumSkillSetsEmail: number;
  maximumSkillSetsPhone: number;

  constructor(private data: AgentBoardDashboardService, private serviceLevel: ServiceLevelBoardService, private route: ActivatedRoute) {
      this.maximumSkillSetsPhone = 3;
      this.maximumSkillSetsEmail = 3;
      this.maximumSkillSetsAgent = 10;
   }

   viewStateAgents$: Observable<any>;
   viewStateCall$: Observable<any>;
   viewStateEmail$: Observable<any>;

   

  ngOnInit() {
    this.viewStateAgents$ = timer(0, 2000).pipe(
      map(v => this.route.snapshot.paramMap.get('boardLocation')),
      switchMap((bl) => this.data.getAgentBoardData(bl))
    );

    this.viewStateCall$ = timer(0, 2000).pipe(
      map(v => this.route.snapshot.paramMap.get('boardLocation')),
      switchMap((bl) => this.serviceLevel.getServiceLevelBoardData(bl, "serviceLevelPhone"))
    );

    this.viewStateEmail$ = timer(0, 2000).pipe(
      map(v => this.route.snapshot.paramMap.get('boardLocation')),
      switchMap((bl) => this.serviceLevel.getServiceLevelBoardData(bl, "serviceLevelEmail"))
    );
  }

  showHeader() {
    var x = document.getElementById("pageheader");
    
    x.style.display = x.style.display === "none" ? "block" : "none";

    var t = document.getElementById("headTriger");
    t.style.top = x.style.display === "none" ? "10px" : "60px";

    var i = document.getElementById("headTrigerIcon");
    i.className = x.style.display === "none" ? "fa fa-arrow-down" : "fa fa-arrow-up";
  }

  triggerAgentNotReadyRows() {
    var i = document.getElementById("agentNotReadyTrigger");
    i.className = i.className === "fa fa-arrow-down" ? "fa fa-arrow-up" : "fa fa-arrow-down";
    this.maximumSkillSetsAgent = this.maximumSkillSetsAgent === 10 ? 10000 : 10;
  }
  triggerCallServiceLevelRows() {
    var i = document.getElementById("callServiceLevelTrigger");
    i.className = i.className === "fa fa-arrow-down" ? "fa fa-arrow-up" : "fa fa-arrow-down";
    this.maximumSkillSetsPhone = this.maximumSkillSetsPhone === 3 ? 10000 : 3;
  }
  triggerEmailsServiceLevelRows() {
    var i = document.getElementById("emailsServiceLevelTrigger");
    i.className = i.className === "fa fa-arrow-down" ? "fa fa-arrow-up" : "fa fa-arrow-down";
    this.maximumSkillSetsEmail = this.maximumSkillSetsEmail === 3 ? 10000 : 3;
  }
}
